import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Globe, LogOut, Users, FileCheck, ArrowUpDown, MessageSquare } from 'lucide-react';
import UserManagement from '@/components/admin/UserManagement';
import KYCReview from '@/components/admin/KYCReview';
import TransactionManagement from '@/components/admin/TransactionManagement';
import AdminChat from '@/components/admin/AdminChat';

export default function AdminDashboard() {
  const { signOut } = useAuth();
  const { t, toggleLanguage } = useLanguage();
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20">
      {/* Header */}
      <header className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold">Admin Dashboard</h1>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="icon" onClick={toggleLanguage}>
              <Globe className="h-5 w-5" />
            </Button>
            <Button variant="outline" onClick={signOut}>
              <LogOut className="h-4 w-4 mr-2" />
              {t('logout')}
            </Button>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-8">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
          <TabsList className="grid w-full grid-cols-4 lg:w-fit">
            <TabsTrigger value="users">
              <Users className="h-4 w-4 mr-2" />
              {t('users')}
            </TabsTrigger>
            <TabsTrigger value="kyc">
              <FileCheck className="h-4 w-4 mr-2" />
              {t('kycReview')}
            </TabsTrigger>
            <TabsTrigger value="transactions">
              <ArrowUpDown className="h-4 w-4 mr-2" />
              {t('allTransactions')}
            </TabsTrigger>
            <TabsTrigger value="chat">
              <MessageSquare className="h-4 w-4 mr-2" />
              {t('chat')}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="users">
            <UserManagement />
          </TabsContent>

          <TabsContent value="kyc">
            <KYCReview />
          </TabsContent>

          <TabsContent value="transactions">
            <TransactionManagement />
          </TabsContent>

          <TabsContent value="chat">
            <AdminChat />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}